import { makeStyles } from '../../../../styles';
const DEFAULT_ICON_SIZE = '20px';
const getSizeSpecificContentStyles = (size) => {
    switch (size) {
        case 'h4':
            return {
                padding: '24px 20px',
            };
        default:
            return {
                padding: '20px',
            };
    }
};
const getIconSize = (size) => {
    switch (size) {
        case 'h4':
            return '24px';
        default:
            return DEFAULT_ICON_SIZE;
    }
};
const useStyles = makeStyles((theme) => ({
    titleContainer: {
        display: 'flex',
    },
    closeButton: {
        position: 'absolute',
        top: '8px',
        right: '8px',
    },
    closeIcon: {
        fontSize: '16px',
    },
    root: {
        borderTop: 'none',
        borderRight: 'none',
        borderBottom: 'none',
        borderLeftWidth: 6,
        borderColor: theme.colors.primary.main,
        '&.warning': {
            borderColor: theme.colors.warning.main,
        },
        '&.success': {
            borderColor: theme.colors.success.main,
        },
        '&.error': {
            borderColor: theme.colors.error.main,
        },
        position: 'relative',
    },
    content: ({ typographyVariant = 'body2' }) => (Object.assign(Object.assign(Object.assign({ margin: '-16px' }, theme.typography[typographyVariant]), getSizeSpecificContentStyles(typographyVariant)), { '&:last-child': Object.assign({}, getSizeSpecificContentStyles(typographyVariant)), flexDirection: 'row', alignItems: 'center', backgroundColor: theme.colors.primary.light, '&.warning': {
            backgroundColor: theme.colors.warning.light,
        }, '&.success': {
            backgroundColor: theme.colors.success.light,
        }, '&.error': {
            backgroundColor: theme.colors.error.light,
        } })),
    iconWrapper: ({ typographyVariant = 'body2' }) => ({
        display: 'flex',
        alignItems: 'flex-start',
        paddingRight: '10px',
        '&.warning': {
            color: theme.colors.warning.dark,
        },
        '&.success': {
            color: theme.colors.success.main,
        },
        '&.error': {
            color: theme.colors.error.main,
        },
        '&.info': {
            color: theme.colors.primary.main,
        },
        '& svg': {
            width: getIconSize(typographyVariant),
            height: getIconSize(typographyVariant),
        },
    }),
}));
export default useStyles;
//# sourceMappingURL=AlertV2.styles.js.map